export default __webpack_public_path__ + "static/media/raze-eth-uni-closed-stub.56ce918c.png";